module.exports = __webpack_public_path__ + "static/media/WhatIfIMove.f4ebb203.png";